export default {
    methods: {
        formatGatewayName(number) {
            if (number == undefined) return undefined;
            return "DS-Gateway-" + number.toLocaleString("en-US", { minimumIntegerDigits: 2, useGrouping: false });
        },
    },
};
